import { BsFacebook, BsInstagram, BsTwitter } from 'react-icons/bs';

import { Link } from 'react-router-dom';

const UpperHeaderBar = () => {
  return (
    <div className="items-center justify-center hidden w-full h-auto px-5 py-1 bg-white md:flex bg-white-500">
      <div className="flex items-center justify-between w-full max-w-5xl">
        <p className="text-gray-500 text-small">
          Telephone booking and information: &nbsp;
          <a
            href="tel:01772379520"
            className="text-[#846bb9] hover:text-[#6bb2b9]"
          >
            01772 379520
          </a>
          <span> | </span>
          <a
            href="mailto:enquiries@kenworthychiropractic.com"
            className="text-[#846bb9] hover:text-[#6bb2b9] mx-1 ease-in-out duration-300"
          >
            enquiries@kenworthychiropractic.com
          </a>
        </p>
      </div>
      <div className="flex items-center">
        <Link
          target="_blank"
          rel="noopener noreferrer"
          to="https://www.facebook.com/KenworthyChiropractic/"
          className="text-[#846bb9] hover:text-[#6bb2b9] mx-1 ease-in-out duration-300"
          aria-label='facebook'
        >
          <BsFacebook />
        </Link>
        <Link
          target="_blank"
          rel="noopener noreferrer"
          to="https://www.instagram.com/kenworthychiropractic/"
          className="text-[#846bb9] hover:text-[#6bb2b9] mx-1 ease-in-out duration-300"
          aria-label='instagram'
        >
          <BsInstagram />
        </Link>
        <Link
          target="_blank"
          rel="noopener noreferrer"
          to="https://twitter.com/KenworthyChiro"
          className="text-[#846bb9] hover:text-[#6bb2b9] mx-1 ease-in-out duration-300"
          aria-label='twitter / x'
        >
          <BsTwitter />
        </Link>
      </div>
    </div>
  );
};

export default UpperHeaderBar;
